











import { Component, Vue, Prop } from 'vue-property-decorator'
import { TranslateResult } from 'vue-i18n'

@Component<ContentHeader>({})
export default class ContentHeader extends Vue {
  @Prop()
  title!: TranslateResult | string

  @Prop({ default: false })
  large!: boolean

  @Prop({ default: false })
  loading!: boolean
}
